<div
  class="tadkar-notify fixed md:w-[400px] right-5 bottom-5 z-50 text-sm rounded-xl">
  <div *ngFor="let notification of notifications"
    class="card-notify p-4 rounded-xl border border-black-100 shadow-md mt-3 bg-white">
    <ng-container
      *ngTemplateOutlet="notifyTemp;context:{notification:notification}"></ng-container>
  </div>
</div>

<ng-template #notifyTemp let-notification="notification">
  <div id="content" class="flex flex-col rounded-xl"
    [ngClass]="notification.type | lowercase">
    <div class="flex items-center w-full relative rounded-xl">
      <div [ngSwitch]="notification.type" class="icon-wrapper flex text-3xl ">
        <i *ngSwitchCase="'Information'"
          class="ico-FaqCircle tracking-normal text-blue-500"></i>
        <i *ngSwitchCase="'Warning'"
          class="ico-DangerCircle tracking-normal text-yellow-400"></i>
        <i *ngSwitchCase="'Error'"
          class="ico-DangerCircle tracking-normal text-red-400"></i>
        <i *ngSwitchDefault
          class="ico-Check tracking-normal text-green-300"></i>
      </div>
      <!-- --- -->
      <h5 class="grow ms-3 font-medium text-xl text-black-900">{{ notification.title }}</h5>
      <!-- --- -->
      <!-- --- -->
      <div class="closeButton flex rounded-full cursor-pointer" matRipple
        (click)="close(notification)">
        <i class="ico-closecircle tracking-normal text-2xl leading-none"></i>
      </div>
    </div>
    <!-- --- -->
    <div *ngIf="notification.message" id="message"
      class="ps-[43px] mt-2 rounded-xl">
      <div class="text-black-300 text-sm font-normal"
        [innerHtml]="notification.message"></div>
    </div>
  </div>
</ng-template>
